import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-unit7-conclusion',
  templateUrl: './unit7-conclusion.component.html',
  styleUrls: ['./unit7-conclusion.component.css']
})
export class Unit7ConclusionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
